import { useState } from "react"
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ToastNotification from '../../components/ToastNotification';




const EditCompany = () => {
    const { state } = useLocation();
    const navigate = useNavigate()
    const form = state?.form;

    const [forms, setForm] = useState({
        name: form?.name || "",
        email: form?.email || "",
        phone: form?.phone || "",
        password: form?.password || "",
        address: form?.address || "",
        city: form?.city || "",
        state: form?.state || "",
        company_id: form?.company_id || "",
        short_name: form?.short_name || "",
        role: form?.role || "",
        gst: form?.gst || "",
        bank_name: form?.bank_name || "",
        acc_no: form?.acc_no || "",
        branch: form?.branch || "",
        ifsc: form?.ifsc || "",
        esic_no: form?.esic_no || "",
        esic_acct: form?.esic_acct || "",
        esic_office: form?.esic_office || "",
        pan: form?.pan || "",
        aadhaar: form?.aadhaar || "",
        pf_no: form?.pf_no || "",
        fax: form?.fax || "",
        url: form?.url || "",
        pincode: form?.pincode || '',
    });

    // const [files, setFiles] = useState({});

    const [files, setFiles] = useState({
        gst_img: null,
        gomashta_img: null,
        visiting_img: null,
        bill_img: null,
        owner_pan_img: null,
        owner_aadhaar_img: null,
        owner_aadhaar_back: null
    });

   
         const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
       
         const showToast = (msg, bg = 'success') => {
           setToast({ show: true, message: msg, bg });
         };

    const handleFileChange = (e) => {
        setFiles(prev => ({ ...prev, [e.target.name]: e.target.files[0] }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...forms, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();

        Object.keys(forms).forEach(key => data.append(key, forms[key]));
        Object.keys(files).forEach(key => {
            if (files[key]) data.append(key, files[key]);
        });

        try {
            await axios.put(`https://api.skyguard.group/api/edit-company/${form.company_id}`, data, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            showToast("Company updated successfully",'success');

            setTimeout(() => {

                navigate("/admin/companies");
            }, 2000);
            
        } catch (err) {
            console.error(err);
            showToast("Failed to update company",'danger');
        }
    };


    return (
        <>
            <div className='main-section'>

                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    
                      <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                      />
                    <button className='btn btn-primary' onClick={() => navigate('/admin/companies')}> Back</button>

                    <h3 className='my-3 fw-bold fs-5 golos'>Edit Company Detail</h3>
                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>

                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={forms.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="email" placeholder="Email" value={forms.email} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={forms.phone} onChange={handleInputChange} />
                                </div>

                                <div className="col-md-4">
                                    <input type="password" className="form-control" name="password" placeholder="Password" value={forms.password} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="address" placeholder="address" value={forms.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="city" placeholder="city" value={forms.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="state" placeholder="state" value={forms.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={forms.pincode} onChange={handleInputChange} />
                                </div>








                                {/* <div className="col-md-4">
                                <input type="text" className="form-control" name="acc_no" placeholder="acc_no" value={formData.address} onChange={handleInputChange} />
                            </div> */}


                                <h5 className="mt-4">Company Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="company_id" placeholder="Company ID" value={forms.company_id} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="short_name" placeholder="Company Short Name" value={forms.short_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="role" placeholder="Role" value={forms.role} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Enter Your GST Number</label>
                                        <input type="text" className="form-control" name="gst" placeholder="GST" value={forms.gst} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label" > Upload Your GST image or pdf</label>

                                        <input type="file" className="form-control   " name="gst_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Bank Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="bank_name" placeholder="Bank Name" value={forms.bank_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="acc_no" placeholder="Account Number" value={forms.acc_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="branch" placeholder="Branch" value={forms.branch} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="ifsc" placeholder="IFSC" value={forms.ifsc} onChange={handleInputChange} />
                                    </div>


                                </div>

                                <h5 className="mt-4">ESIC Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_no" placeholder="ESIC Number" value={forms.esic_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_acct" placeholder="ESIC Acctount" value={forms.esic_acct} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_office" placeholder="ESIC Office" value={forms.esic_office} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Pan Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Pan</label>
                                        <input type="text" className="form-control" name="pan" placeholder="Pan" value={forms.pan} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Pan</label>
                                        <input type="file" className="form-control" name="owner_pan_img" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>

                                </div>
                                <h5 className="mt-4">Aadhar Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Aadhaar Number</label>
                                        <input type="text" className="form-control" name="aadhaar" placeholder="Aahaar Number" value={forms.aadhaar} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Front Aadhaar Image</label>
                                        <input type="file" className="form-control" name="owner_aadhaar_img" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload Your Back Aadhaar Image</label>
                                        <input type="file" className="form-control" name="owner_aadhaar_back
" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="pf_no" placeholder="PF Number" value={forms.pf_no} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={forms.fax} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="url" placeholder="URL" value={forms.url} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Upload Documents</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <label>Upload your Gomashta Certificate</label>
                                        <input type="file" className="form-control" name="gomashta_img" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload ypur Visiting Card</label>
                                        <input type="file" className="form-control" name="visiting_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Bill Book</label>
                                        <input type="file" className="form-control" name="bill_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>
                                </div>






                                {/* <div className="col-md-4">


                                </div> */}
                                <div className="col-md-12 text-end">
                                    <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                        {/* <MessagePopup  show={popup.show} message={popup.message} onClose={closePopup}  /> */}

                    </div>


                </div>
            </div>
        </>

    )
}

export default EditCompany